import React from 'react'
import { Grid } from '@deal/components'
import { ResponsiveGridProps } from '@deal/components/dist/components/Grid/Grid'
import classnames from 'classnames'
import styles from './styles.css'

interface SidebarAwareGridProps extends ResponsiveGridProps {
  // Force the SidebarAwareGrid to be... a normal Grid.
  // Useful when it would be otherwise painful to dynamically swap out the components.
  unless?: boolean
}

const SidebarAwareGrid: React.SFC<SidebarAwareGridProps> = ({ className, unless, ...props }) => {
  if (unless) {
    return <Grid className={className} {...props} />
  }

  return <Grid className={classnames(className, styles.sidebarAwareGrid)} {...props} />
}

export default SidebarAwareGrid
